import type { GetResultsVerificationV2Params, ResultsVerificationV2Filters } from 'services/results/v2/types'

export const ResultsQueryKeys = {
  All: () => ['results'],

  // Export requests
  AllResultsVerificationV2: (filters: ResultsVerificationV2Filters) => [
    ...ResultsQueryKeys.All(),
    'all-verification-v2',
    filters
  ],
  WorkspacesFromExportRequests: () => [...ResultsQueryKeys.All(), 'workspaces-from-export-requests'],
  RequestersFromExportRequests: () => [...ResultsQueryKeys.All(), 'requesters-from-export-requests'],

  // Filters
  Filters: () => [...ResultsQueryKeys.All(), 'filters'],
  LabelsFromExportRequests: () => [...ResultsQueryKeys.Filters(), 'labels'],

  // Verification
  ResultsVerificationV2: (params?: GetResultsVerificationV2Params) => [
    ...ResultsQueryKeys.All(),
    'verification-v2',
    ...(params ? [params] : [])
  ],
  ResultsVerificationAssignees: () => [...ResultsQueryKeys.All(), 'results-verification-assignees'],
  AssignableAssignees: (resultId: string) => [...ResultsQueryKeys.All(), 'assignable-assignees', resultId],

  // Result details
  ResultDetails: (resultId: string) => [...ResultsQueryKeys.All(), 'result-details', resultId],
  AutomatedChecksReport: (resultId: string, jobId: string) => [
    ...ResultsQueryKeys.All(),
    'automated-checks-report',
    resultId,
    jobId
  ]
}
